import {Signal} from "../core/Signal";
import {voOptionsIdle} from "../data/VoiceOver";
import {CaptionManager} from "../managers/CaptionManager";
import {VoiceOverManager} from "../managers/VoiceOverManager";

export class IdleVO {

    public readonly onVOStart = Signal<(vo: string | string[]) => void>();

    private readonly vo: Array<string | string[]>;
    private _timeout?: number;

    constructor(...vo: Array<string | string[]>) {
        this.vo = vo;
    }

    public start(timeout = 8) {
        this.stop();
        this._timeout = window.setTimeout(() => {
            const vo = this.vo[0];
            let isPlaying = true;
            VoiceOverManager.instance.playVO(vo, {
                ...voOptionsIdle,
                callback: (success: boolean) => {
                    isPlaying = success;
                },
            });
            if (isPlaying) {
                this.vo.push(this.vo.shift()!);
                const a = typeof vo === "string" ? [vo] : vo;
                let d = 0;
                for (const v of a) {
                    d += CaptionManager.instance.getDuration(v);
                }
                this.onVOStart(vo);
                this.start(d + 8);
            } else {
                this.start();
            }

        }, timeout * 1000);
    }

    public stop() {
        if (this._timeout !== undefined) {
            clearTimeout(this._timeout);
            this._timeout = undefined;
        }
    }

    public destroy() {
        this.stop();
        this.onVOStart.remove();
    }
}
